<template>
  <validation-provider
    v-slot="{ errors }"
    name="totimeValidation"
    :rules="rules"
  >
    <v-text-field
      v-model="data"
      :outlined="isOutlined"
      autocomplete="off"
      placeholder="hh:mm"
      :error-messages="errors[0]"
      @keydown.enter.prevent="save"
      @blur="save"
    />
  </validation-provider>
</template>

<script>
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  import moment from 'moment'
  import { required } from 'vee-validate/dist/rules'

  export default {
    name: 'InputTimePicker',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    props: ['value', 'isOutlined', 'plan', 'rules'],
    data () {
      return {
        data: '',
      }
    },
    watch: {
      data (data) {
        if (data) {
          if (data.length === 1 && parseInt(data) > 4) {
            this.data = '0' + data + ':'
          } else if (data.length === 2) return (this.data = data + ':')
        }
      },
      value () {
        this.data = this.value ? this.value : ''
      },
    },
    mounted () {
      extend('checktime', {
        events: ['blur'],
        validate (value) {
          if (/^[0,1,2,3,4]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$/g.test(value)) {
            const timeSplited = value.split(':')
            if (timeSplited[0] === 24) return false
            return true
          }
          return false
        },
        message: this.$t('validator.invalidTimeFormat'),
      })

      extend('required', {
        ...required,
        message: this.$t('validator.required'),
      })

      extend('checktime24h', {
        events: ['blur'],
        validate (value) {
          if (!moment(value, 'HH:mm').isValid()) return false
          return true
        },
        message: this.$t('validator.invalidTimeFormat'),
      })

      extend('check48h', {
        events: ['blur'],
        validate (value) {
          const timeStart = parseInt(value.slice(0, 2))
          const timeEnd = (parseInt(value.slice(3, 5)) / 60)
          const time = parseFloat(timeStart + timeEnd).toFixed(2)

          return time <= 48
        },
        message: this.$t('validator.invalidTimeFormat'),
      })
    },
    methods: {

      save () {
        if (/^[0,1,2,3,4]{1}[0-9]{1}:[0-5]{1}[0-9]{1}$/g.test(this.data)) {
          this.$emit('save', { data: this.data, plan: this.plan })
        } else {
          this.data = this.value ? this.value : ''
        }
      },
    },
  }
</script>

<style scoped>

</style>
